import { message } from 'antd';
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import moment from 'moment'
import { ApiHelper } from '../../utils/ApiHelper'

import Picker from './Picker'
import { defaultExpenseCategories } from './categories.js'

export function updateUser(values) {
  return (dispatch, getState) => {
    dispatch({type: 'UPDATE_USER_REQUEST', values})
    return ApiHelper
      .updateUser(values)
      .then(json => {

          if (json.status != 201) console.error(json)

          dispatch({
            type: 'UPDATE_USER_SUCCESS',
            user: json.data
          })

        return json

      })

  }
}


const mapStateToProps = (state, ownProps) => {
  const custom_expense_categories = state.models.user.custom_expense_categories

  return {
    defaultValue: ownProps.defaultValue,
    custom_expense_categories,
    categories: [
      ...defaultExpenseCategories
    ],

  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onSelect: (v)=>{
      ownProps.onSelect(v)
    },
    onUpdateCustomExpenseCategories: (custom_expense_categories)=> {
      dispatch(updateUser({custom_expense_categories}))

    }
    // onSelectCategory: (category)=> {
    //   if (category.trim()=='') return
    //   dispatch(change('transaction', 'category', category))
    //   // if not part of given categories, set custom_expense_categories
    //   // dispatch(change('transaction', 'category', category))
    // },
    // ownProps
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Picker)



// WEBPACK FOOTER //
// ./src/core/CategoryPicker/index.js